(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var closeButton = document.querySelector('.sticky-video .btn-close-custom');
    if (closeButton) {
        closeButton.addEventListener('click', function(event) {
            var stickyVideoSection = event.target.closest('.sticky-video');
            if (stickyVideoSection) {
                stickyVideoSection.classList.add('slide-out-left');
                
                // Ocultar o vídeo após a animação ser concluída
                setTimeout(function() {
                    stickyVideoSection.style.display = 'none';
                }, 500); // O tempo aqui (500ms) deve corresponder à duração da animação no CSS
            }
        });
    }
});


  } catch(e) { console.error(e); }
})();
})();
